export default __webpack_public_path__ + "static/media/double-double-border-none.2df660fc.svg";